import(/* webpackMode: "eager" */ "/builds/empiriecom/core/frontend/turborepo/apps/shopping/src/app/[lang]/(shop)/not-found.tsx");
